import * as yup from 'yup'

import yupLocaleDe from './Locale/de'

// setLocale needs to be called at the top of the file, see: https://github.com/jquense/yup/pull/1371
yup.setLocale(yupLocaleDe)

export default yup
